import { Component, OnInit } from '@angular/core';
import { environment } from './../../../../environments/environment';

@Component({
  	selector: 'app-toolcards-mind-mapping',
  	templateUrl: './toolcards-mind-mapping.component.html',
  	styleUrls: ['./toolcards-mind-mapping.component.scss']
})
export class ToolcardsMindMappingComponent implements OnInit {
	public env;
  	constructor() { }

  	ngOnInit() {
  		this.env=environment;
  	}

}
